// REAVERFIT — Move Schema Breadcrumbs to Collection Toolbar
// Solution robuste pour déplacer l'app breadcrumb dans la toolbar

(function() {
  // Ne s'exécute que sur les collections
  if (!document.body || !document.body.className.match(/\btemplate-collection\b/)) return;

  function qsAll(sel, root) { return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function first(sel) { return document.querySelector(sel); }

  // 1) Trouve la toolbar cible
  var toolbarInner =
    first('.collection-toolbar__inner') ||
    first('.collection-toolbar .container') ||
    first('.collection-toolbar');

  if (!toolbarInner) return;

  // 2) Trouve le VRAI breadcrumb rendu par l'app (plusieurs possibilités)
  var breadcrumb =
    first('.schema-breadcrumbs') ||
    first('[data-schema-breadcrumbs], .breadcrumbs-app, .app-breadcrumbs') ||
    first('.breadcrumbs'); // fallback si ton thème a déjà .breadcrumbs

  if (!breadcrumb) return;

  // Évite les doubles déplacements
  if (breadcrumb.dataset.rfMoved === '1') return;

  // 3) Cache l'original (pour ne pas le voir au-dessus)
  //    On clone le noeud et on l'insère dans la toolbar
  var clone = breadcrumb.cloneNode(true);
  clone.classList.add('rf-breadcrumbs--in-toolbar');
  breadcrumb.style.display = 'none';
  breadcrumb.setAttribute('aria-hidden', 'true');
  breadcrumb.dataset.rfMoved = '1';

  // 4) Insère à DROITE dans la toolbar, après la zone "Trier par"
  var buttonList = first('.collection-toolbar__button-list');
  if (buttonList) {
    // Insert après la button list (à droite)
    toolbarInner.insertBefore(clone, buttonList.nextSibling);
  } else {
    // Fallback: ajoute à la fin
    toolbarInner.appendChild(clone);
  }

  // 5) Style: force l'alignement propre
  toolbarInner.style.display = 'flex';
  toolbarInner.style.alignItems = 'center';
  toolbarInner.style.justifyContent = 'space-between';
})();
